import React from "react";
import { Route, Routes } from "react-router-dom";
import AdminDashboard from "./dashboard";
import CreateInspectionTemplate from "./createInspectionTemplate";

const AdminContents = () => {
  return (
    <Routes>
      <Route path="/" element={<AdminDashboard />} />
      <Route
        path="/createInspectionTemplate"
        element={<CreateInspectionTemplate />}
      />
    </Routes>
  );
};

export default AdminContents;
